import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';

export default function MissionVision(){
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Paper elevation={0} sx={{ p:3, border: '1px solid #eee' }}>
          <Typography variant="h5" sx={{ fontWeight: 800, mb: 1 }}>Misión</Typography>
          <Typography>
            Ofrecer un servicio integral de calidad relacionado con metales finos, garantizando un precio justo, atención eficiente y confiabilidad en nuestro trabajo
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={12} md={6}>
        <Paper elevation={0} sx={{ p:3, border: '1px solid #eee' }}>
          <Typography variant="h5" sx={{ fontWeight: 800, mb: 1 }}>Visión</Typography>
          <Typography>
            Ser la empresa más confiable del mercado ecuatoriano, destacándonos  por nuestra integridad en los servicios relacionados con la TASACIÓN - COMPRA  - VENTA de oro y plata
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
}